import React from 'react';

import { groupBy, orderBy } from 'lodash';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { HeaderTitle } from '@src/components/common';
import Table from '@src/components/common/Availability/AvailabilityTable';
import { GroupedDropdown } from '@src/components/GroupedDropdown';
import { productTitle } from '@src/components/products';

import Map from './ProductAvailabilityMap';
import Subtitle from './ProductAvailabilitySubtitle';
import styles from './ProductAvailabilityView.scss';

const ProductAvailabilityView = ({
    products,
    onProductChange,
    currentItem,
    page,
}) => {

    const renderDropdown = () => {
        // Group products by product_line and format names
        const groupedProducts = groupBy(products, (p) => {
            const line = p.product_line || 'Other';
            if (line === 'Foremost 5.0 Agent360') {
                return 'Foremost 5.0 (Agent360)';
            }
            if (line === 'Foremost Signature Agent360') {
                return 'Foremost Signature (Agent360)';
            }
            if (line === 'Foremost Signature ARS') {
                return 'Foremost Signature (ARS)';
            }
            return line;
        });
        const sortedProductLines = orderBy(Object.keys(groupedProducts));

        const groupedList = sortedProductLines.map((productLine) => ({
            group: productLine,
            items: orderBy(groupedProducts[productLine], (p) => productTitle(p, { noHtml: true }))
                .map((product) => ({
                    id: product.slug,
                    title: productTitle(product),
                })),
        }));

        return (
            <Row className="justify-content-center">
                <Col sm={12} md={4} className="mb-3">
                    <GroupedDropdown
                        defaultSelection="No product"
                        groupedList={groupedList}
                        selectedOption={currentItem && currentItem.slug}
                        title="Jump to product"
                        onChange={onProductChange}
                    />
                </Col>
            </Row>
        );
    };

    const renderTitle = () => {
        if (!currentItem) {
            return '';
        }

        return productTitle(currentItem);
    };

    const renderSubtitleText = () => {
        return (
            <>
                To find out which products you can write in each state, select a product from the list below
            </>
        );
    };

    const renderAvailability = () => {
        const allItems = [
            ...products,
        ];

        return (
            <>
                <Map currentItem={currentItem} allItems={allItems} />
                {
                    currentItem
                        && <Table
                            currentItem={currentItem}
                            page={page}
                        />
                }
            </>
        );
    };

    return (
        <Col id="ProductAvailMap" className={styles.products_map_home_container}>
            <HeaderTitle
                title="Availability Map"
                subTitle={
                    <Subtitle
                        productSubtitle={renderTitle()}
                        text={renderSubtitleText()}
                    />
                }
            />
            { renderDropdown() }
            { renderAvailability() }
        </Col>
    );
};

ProductAvailabilityView.propTypes = {
    products: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        slug: PropTypes.string.isRequired,
        name: PropTypes.string,
        is_new: PropTypes.bool,
    })).isRequired,
    onProductChange: PropTypes.func.isRequired,
    currentItem: PropTypes.shape({
        id: PropTypes.number.isRequired,
        slug: PropTypes.string.isRequired,
        is_new: PropTypes.bool,
        name: PropTypes.string,
        platform: PropTypes.string,
    }),
    page: PropTypes.number,
};

export default React.memo(ProductAvailabilityView);
